/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type {
  EdyAllUsersLoginAsOptions,
  EdyAllUsersLoginAsResponses,
} from '../models/EdyAllUsersLoginAs'
import {
  edyAllUsersLoginAsResponseSchema,
  edyAllUsersLoginAsErrorSchema,
  edyAllUsersLoginAsBodySchema,
} from '../schemas/edyAllUsersLoginAsSchema'

/**
 * @summary Support impersonation: issues a V4 token pair for the target user under a support case. Records the case +
 * logs StartSupportCase. Login gates never apply to the support session; instead `supportSummary` lists
 * what would stop the target on a real login (lockout, login code, password/terms/org gates).
 * {@link /api/v4/edyAllUsers/:id/loginAs}
 */
export function edyAllUsersLoginAs<ThrowOnError extends boolean = true>(
  options: Options<EdyAllUsersLoginAsOptions, ThrowOnError>
): Unwrappable<RequestResult<EdyAllUsersLoginAsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/edyAllUsers/{id}/loginAs',
      security: [{ type: 'http', scheme: 'bearer' }],
      validator: {
        request: edyAllUsersLoginAsBodySchema,
        response: edyAllUsersLoginAsResponseSchema,
        error: edyAllUsersLoginAsErrorSchema,
      },
      contentType: { request: 'application/json-patch+json' },
      ...config,
    }) as Promise<RequestResult<EdyAllUsersLoginAsResponses, ThrowOnError>>
  )
}
